import { AgentConfigOptions as ElasticAPMNodeOptions } from 'elastic-apm-node';
import { Transaction } from '@elastic/apm-rum';

export type { ElasticAPMNodeOptions };

export type PageLoad = {
  pageLoadTraceId?: string;
  pageLoadSpanId?: string;
  pageLoadSampled?: boolean;
};

export type ElasticAPMRumOptions = Omit<
  ElasticAPMNodeOptions,
  'secretToken' | 'transactionIgnoreUrls' | 'usePathAsTransactionName'
> &
  PageLoad & { disableInstrumentations?: string | string[] | undefined };

export const setApmServiceLabel = (
  transaction: Transaction | undefined,
  mode: string
) => {
  if (transaction) {
    transaction.addLabels({ ['service']: mode });
  }
};

export const elasticApmOptions = {
  serviceName: `leanback-areena-${process.env['APP_ENV']}`,
  serverUrl: `https://apm${
    process.env['APP_ENV'] === 'production' ? '' : '-test'
  }.aws.yle.fi`,
  secretToken: process.env['APM_SECRET_TOKEN'],
  transactionSampleRate: process.env['APP_ENV'] === 'production' ? 0.05 : 1,
  serviceVersion: process.env['VERSION'] || '',
  environment: process.env['APP_ENV'] || 'development',
  transactionIgnoreUrls: ['/ping', '/metrics'],
  usePathAsTransactionName: true,
  active: ['production', 'test', 'staging'].includes(
    process.env['APP_ENV'] || ''
  ),
};
